import { c as _c } from "react/compiler-runtime";
import type { FootprintVariant } from '@onefootprint/footprint-js-legacy';
import { Layout as AppLayout, useFootprintProvider } from '@onefootprint/idv2';
import type React from 'react';
import { useBifrostMachine } from '../bifrost-machine-provider';
import useInlineAutoResize from './use-inline-auto-resize';
type LayoutProps = {
  children: React.ReactNode;
  variant?: FootprintVariant;
};
const Layout = t0 => {
  const $ = _c(10);
  const {
    children,
    variant
  } = t0;
  const footprint = useFootprintProvider();
  const [state] = useBifrostMachine();
  const {
    config
  } = state.context;
  const isSandbox = config?.isLive === false;
  const fitContent = useInlineAutoResize(variant === "inline");
  let t1;
  if ($[0] !== footprint) {
    t1 = () => {
      footprint.cancel();
      footprint.close();
    };
    $[0] = footprint;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClose = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      hasDesktopBorderRadius: true
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== config || $[5] !== fitContent || $[6] !== handleClose || $[7] !== isSandbox || $[8] !== variant) {
    t3 = <AppLayout variant={variant} options={t2} isSandbox={isSandbox} fitContent={fitContent} config={config} onClose={handleClose}>{children}</AppLayout>;
    $[3] = children;
    $[4] = config;
    $[5] = fitContent;
    $[6] = handleClose;
    $[7] = isSandbox;
    $[8] = variant;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default Layout;